
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/docflo",
      function () {
        return require("private-next-pages/features/docflo.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/docflo"])
      });
    }
  